import {Row, Col} from "antd"
import {BaseNewFilter} from "uiKit"
import {KlassDropdown} from "components/Select"
import styles from "./Filter.module.css"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import ProgramVersionSelect from "components/ProgramVersionSelect"

type Props = {
    searchValue: string
    changeSearch: any
    onApplyFilter: any
    clearFilter: any
    currentFilter: any
    onChangeFilter: any
    setCurrentFilter: any
}

const statusOptions = [
    {value: null, label: "All"},
    {value: true, label: "Active"},
    {value: false, label: "Inactive"}
]

const Filter = (props: Props) => {
    const {searchValue, changeSearch, onApplyFilter, clearFilter, currentFilter, onChangeFilter} = props

    return (
        <BaseNewFilter
            className={styles.filterContainer}
            searchValue={searchValue}
            onSearchInput={changeSearch}
            onClick={onApplyFilter}
            onClickClear={clearFilter}
            filter={currentFilter}>
            <Row gutter={[40, 32]}>
                <Col span={12}>
                    <CampusSelect
                        isMulti
                        isClearable
                        placeholder="Campus"
                        value={currentFilter.campuses}
                        onChange={(newValue) => {
                            onChangeFilter("campuses", newValue)
                        }}
                    />
                </Col>

                <Col span={12}>
                    <ProgramSelect
                        isMulti
                        isClearable
                        placeholder="Programs"
                        value={currentFilter.programs}
                        onChange={(newValue) => onChangeFilter("programs", newValue)}
                    />
                </Col>
                <Col span={12}>
                    <ProgramVersionSelect
                        isMulti
                        isClearable
                        placeholder="Program Versions"
                        value={currentFilter.programVersions}
                        onChange={(newValue) => onChangeFilter("programVersions", newValue)}
                    />
                </Col>
                <Col span={12}>
                    <KlassDropdown
                        valueKey="value"
                        labelKey="label"
                        placeholder="Status"
                        isClearable
                        value={statusOptions.find((opt) => opt.value === currentFilter.isActive)}
                        options={statusOptions}
                        onChange={(newValue) => onChangeFilter("isActive", newValue?.value ?? null)}
                    />
                </Col>
            </Row>
        </BaseNewFilter>
    )
}

export {Filter}
